module.exports = __webpack_public_path__ + "img/Flora & Fauna Science.f8a1a539.jpg";